import { useFetchAccountIdentities } from '@/containers/Identities/api';
import { selectCurrentAccountId } from '@/lib/redux/app.selectors';
import { setAccountIdentities } from '@/lib/redux/app.slice';
import { useAppDispatch } from '@/lib/redux/store';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useUser from './useUser';

const useInitializeFetchAccountIdentities = () => {
  const dispatch = useAppDispatch();
  const { isLoggedIn } = useUser();
  const currentAccountId = useSelector(selectCurrentAccountId);
  const { isLoading, data } = useFetchAccountIdentities(
    currentAccountId || undefined,
    isLoggedIn && !!currentAccountId
  );

  // Update redux
  useEffect(() => {
    if (data && !isLoading) {
      if (data.data) {
        dispatch(setAccountIdentities(data.data.identities ?? []));
      }
    }
  }, [data, dispatch, isLoading]);
};

export default useInitializeFetchAccountIdentities;
